import { Colors } from '@amelio/ui-library';

import type { ProficiencyLevel } from '@/types/competencies/ProficiencyLevel';

export const MIN_PROFICIENCY_LEVELS = 3;

export const MAX_PROFICIENCY_LEVELS = 6;

const ICON_COLOR = {
    teal: Colors.PRIMARY,
    green: Colors.SUCCESS,
    blue: Colors.INFO,
    orange: Colors.WARNING,
    red: Colors.ERROR,
    yellow: Colors.CHART_YELLOW,
    black: Colors.BLACK,
    pink: Colors.PINK,
} as const;

export const PROFICIENCY_LEVEL_ICON_OPTIONS = [
    { icon: 'essential-tick-circle', nameKey: 'mastered', color: ICON_COLOR.teal },
    { icon: 'arrow-arrow-right', nameKey: 'almostAcquired', color: ICON_COLOR.blue },
    { icon: 'electronics-clock', nameKey: 'inProgress', color: ICON_COLOR.orange },
    { icon: 'essential-danger', nameKey: 'notMet', color: ICON_COLOR.red },
    { icon: 'essential-cup', nameKey: 'trophy', color: ICON_COLOR.orange },
    { icon: 'school-award', nameKey: 'award', color: ICON_COLOR.teal },
    { icon: 'support-medal-star', nameKey: 'medal', color: ICON_COLOR.orange },
    { icon: 'support-star', nameKey: 'star', color: ICON_COLOR.yellow },
    { icon: 'essential-crown-1', nameKey: 'crown', color: ICON_COLOR.yellow },
    { icon: 'cryptocompany-target', nameKey: 'target', color: ICON_COLOR.red },
    { icon: 'essential-flag', nameKey: 'flag', color: ICON_COLOR.teal },
    { icon: 'support-magic-star', nameKey: 'excellence', color: ICON_COLOR.black },
    { icon: 'support-like-1', nameKey: 'thumbsUp', color: ICON_COLOR.green },
    { icon: 'support-dislike', nameKey: 'thumbsDown', color: ICON_COLOR.red },
    { icon: 'business-trend-up', nameKey: 'progress', color: ICON_COLOR.green },
    { icon: 'business-trend-down', nameKey: 'regression', color: ICON_COLOR.red },
    { icon: 'business-chart-1', nameKey: 'results', color: ICON_COLOR.black },
    { icon: 'essential-gauge', nameKey: 'measure', color: ICON_COLOR.blue },
    { icon: 'essential-verify', nameKey: 'validated', color: ICON_COLOR.green },
    { icon: 'essential-close-circle', nameKey: 'failure', color: ICON_COLOR.red },
    { icon: 'time-timer', nameKey: 'ongoing', color: ICON_COLOR.orange },
    { icon: 'notifications-lamp-on', nameKey: 'idea', color: ICON_COLOR.yellow },
    { icon: 'essential-rocket', nameKey: 'liftoff', color: ICON_COLOR.pink },
    { icon: 'school-teacher', nameKey: 'graduate', color: ICON_COLOR.teal },
] as const;

/**
 * Mirrors `ProficiencyLevelSeeder.GetDefaultLevels()` on the server, which is what a company
 * actually receives: four levels, one per outcome — reached, nearly, on the way, not yet.
 * The words are the icon catalogue's own, so the picker and the seeded row agree.
 */
export const DEFAULT_PROFICIENCY_LEVELS: ProficiencyLevel[] = [
    { icon: 'achieved', label: { fr: 'Maîtrisé', en: 'Mastered' }, sortOrder: 0 },
    { icon: 'almostAchieved', label: { fr: 'Presque acquis', en: 'Almost there' }, sortOrder: 1 },
    { icon: 'evolution', label: { fr: 'En évolution', en: 'In progress' }, sortOrder: 2 },
    { icon: 'notMet', label: { fr: 'Non atteint', en: 'Not met' }, sortOrder: 3 },
];
